var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fastNews" }, [
    _c("h2", { staticClass: "normal" }, [_vm._v("小鸡快讯")]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("div", { staticClass: "inputBox" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.tag_name,
              expression: "tag_name"
            }
          ],
          attrs: { placeholder: "标题", rows: "5", cols: "60" },
          domProps: { value: _vm.tag_name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.tag_name = $event.target.value
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("div", { staticClass: "inputBox" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.words,
              expression: "words"
            }
          ],
          attrs: { placeholder: "正文", rows: "10", cols: "80" },
          domProps: { value: _vm.words },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.words = $event.target.value
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "normal" }, [
      _c("input", { attrs: { type: "file" }, on: { change: _vm.chooseImage } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "imageBox" },
      _vm._l(_vm.images, function(url, index) {
        return _c("div", { key: index, staticClass: "imageItem" }, [
          _c("img", {
            attrs: { src: url.replace("_mini.jpg", ""), preview: "8" }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.delImage(index)
                }
              }
            },
            [_vm._v("删除")]
          )
        ])
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "normal" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
          [_vm._v("上传")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ff87a66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ff87a66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/FastNews.vue
// module id = null
// module chunks = 